import { Directive, ElementRef, Inject, OnInit } from '@angular/core';
import { THEME_TOKEN, Theme } from '../../../types/theme.types';
import { componentStylesByTheme } from '../../../utils/theme.utils';
import {
  stepperKnobIndicatorStylesSAG,
  stepperKnobIndicatorStylesSHS,
} from './stepper-knob-indicator.styles';
import { style } from '../../../utils/style.utils';

@Directive({
  selector: '[sag-ui-stepper-knob-indicator]',
})
export class StepperKnobIndicatorDirective implements OnInit {
  constructor(
    @Inject(THEME_TOKEN) private readonly theme: Theme,
    private readonly elementRef: ElementRef<HTMLInputElement>
  ) {}

  ngOnInit(): void {
    const inputStyles = componentStylesByTheme(
      this.theme,
      stepperKnobIndicatorStylesSAG,
      stepperKnobIndicatorStylesSHS
    );

    style(this.elementRef, inputStyles());
  }
}
